<template>
    <div class="block-image-strip" >
        <div class="capper">
            <div class="capper-padded-4x">
                <div class="grid-holder" :class="gridClass">
                    <div class="grid-item" v-for="(img, localIndex) in json.imageStrip" :key="localIndex">
                        <div
                            class="stripimg"
                            @click="handleImageClick(localIndex)"
                            :style="[imageStyle, img.bgStyle]"
                        >
                            <div class="plus-circle"><span>+</span></div>
                        </div>
                        <div v-if="img.caption" class="caption" v-html="img.caption"/>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ImageStrip",
    props: {
        json: {
            type: Object,
            required: true,
        },
        allJson: {
            type: Object,
            required: true,
        }
    },
    computed: {
        gridClass() {
            const count = this.json.imageStrip.length;
            if (count === 1) {
                return 'grid-1';
            } else if (count === 2) {
                return 'grid-2';
            } else {
                return 'grid-3';
            }
        },
        combinedArray() {
            if (!this.allJson || !this.allJson.contentBlocks) return [];
            return this.allJson.contentBlocks
                .filter(block => block.type === 'imageStrip' && block.imageStrip && block.imageStrip.length)
                .reduce((acc, block) => acc.concat(block.imageStrip), []);
        },
        commonAspectRatio() {
            const images = this.json.imageStrip;
            if (!images || images.length === 0) return 1; // Fallback to 1:1
            // Build a frequency map; round aspect ratios to two decimals
            const frequency = {};
            images.forEach(image => {
                const ratio = image.aspectRatio.toFixed(2);
                frequency[ratio] = (frequency[ratio] || 0) + 1;
            });
            let mostCommon = null;
            let maxCount = 0;
            for (const ratio in frequency) {
                if (frequency[ratio] > maxCount) {
                    maxCount = frequency[ratio];
                    mostCommon = parseFloat(ratio);
                }
            }
            // If all are unique, use the first image's aspect ratio.
            return maxCount === 1 ? images[0].aspectRatio : mostCommon;
        },
        imageStyle() {
            const ratio = this.commonAspectRatio; // width/height
            // Using the padding-bottom trick for a responsive box:
            const paddingPercent = 100 / ratio;
            // We assume that if the height (as a percentage of the width) would exceed 70vh,
            // we need to switch to a capped style.
            // Note: 70vh is relative to the viewport, while paddingPercent is relative to the container width.
            // You might need to adjust the condition based on your design.

            // if (paddingPercent > 70) {
            //     return {
            //         backgroundSize: 'cover',
            //         backgroundPosition: 'center',
            //         height: '70vh',
            //         // Calculate width so that aspect ratio is maintained: width = height * ratio
            //         width: `calc(70vh * ${ratio})`,
            //         margin: '0 auto'  // Center the element horizontally
            //     };
            // } else {
                return {
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    paddingBottom: `${paddingPercent}%`
                };
            //}
        }
    },
    methods: {
        handleImageClick(localIndex) {
            const currentImage = this.json.imageStrip[localIndex];
            const globalIndex = this.combinedArray.findIndex(image => image.url === currentImage.url);
            if (globalIndex !== -1) {
                this.openSlideshow(globalIndex);
            }
        },
        openSlideshow(index) {
            this.$store.commit('openPopup', {
                gallery: true,
                startingIndex: index,
                items: this.combinedArray
            });
        }
    }
}
</script>